import React from "react";
import { Link } from "react-router-dom";
import { Scale, X } from "lucide-react";
import { useCompare } from "../lib/compare";

export const CompareBar = () => {
  const { count, max, clear } = useCompare();
  if (count === 0) return null;
  const ready = count >= 2;
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-midnight text-white shadow-2xl border border-gold/40 rounded-sm flex items-center gap-3 px-4 py-3 w-[calc(100%-2rem)] max-w-md"
      data-testid="compare-bar"
    >
      <Scale size={18} className="text-gold shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-widest text-gold font-semibold">
          {count} / {max} auto selezionate
        </p>
        <p className="text-[10px] text-white/60 mt-0.5">
          {ready ? "Pronto per il confronto" : "Aggiungine almeno 2 per confrontare"}
        </p>
      </div>
      <button
        onClick={clear}
        className="p-1.5 text-white/50 hover:text-white transition-colors"
        aria-label="Svuota confronto"
        data-testid="compare-clear-btn"
      >
        <X size={14} />
      </button>
      <Link
        to="/confronta"
        aria-disabled={!ready}
        onClick={(e) => { if (!ready) e.preventDefault(); }}
        className={`px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm transition-colors ${
          ready
            ? "bg-gold text-midnight hover:bg-gold/90"
            : "bg-white/10 text-white/40 cursor-not-allowed"
        }`}
        data-testid="compare-go-btn"
      >
        Confronta
      </Link>
    </div>
  );
};

export default CompareBar;
